import { centerable, stylable } from '../decorators';
import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const socialSpec = stylable(centerable({
  content: '',
  group: 'block',
  attrs: {
    type: {
      default: 'social'
    },
    items: {},
    alignment: {}
  },
  toDOM(_node) {
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.social} intercom-social-container`
    }];
  }
}));